import React from 'react';
import { Mail, Phone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Social from './Social';

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="text-gray-600 py-12 px-4 border-t border-pink-500/20 bg-white/90"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4 text-pink-400">Arlene Tarot</h3>
            <p className="text-gray-600">
              {t('footer.tagline')}
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4 text-pink-400">{t('footer.contactTitle')}</h3>
            <div className="space-y-2">
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4 text-gray-600" />
                <span className="text-gray-600">+53 58026042</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4 text-gray-600" />
                <span className="text-gray-600">+53 63131261</span>
              </div>
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4 text-gray-600" />
                <a href="mailto:arlene.set2012@gmail.com" className="text-gray-600 hover:text-pink-400 hover:underline transition-colors duration-200">arlene.set2012@gmail.com</a>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4 text-pink-400">{t('footer.followTitle')}</h3>
            <Social />
            <p className="mt-4 text-sm text-gray-600">@tarotdearlene</p>
          </div>
        </div>

        <div className="border-t border-gray-300 mt-8 pt-8 text-center text-sm text-gray-600">
          <p>&copy; {new Date().getFullYear()} Arlene Tarot. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
